<template>
    <v-text-field
        :key="key"
        :model-value="daysCount"
        :name="name"
        :prefix="`${$t('day', daysCount)}:`"
        bg-color="white"
        data-cy="days-selector"
        type="number"
        hide-details
        single-line
        variant="outlined"
        class="input--no-arrows"
        @update:model-value="inputDay"
    />
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class DaysSelect extends Vue {
        @VModel() daysCount
        @Prop({required: true}) name
        @Prop({default: 365}) max

        key = 0

        inputDay(v) {
            let value = !v ? 0 : parseInt(v.length > String(this.max).length ? v.slice(-1) : v, 10)
            if (value < 1 && String(value).length > 1) value = 1
            else if (value === 0 && String(value).length <= 1) value = 1
            else if (value > this.max) value = this.max
            if (this.daysCount === value) this.key++
            this.daysCount = value
        }
    }

    export default DaysSelect
</script>
